// extracted by mini-css-extract-plugin
module.exports = {"base":"threeCollection9Stories-m__base__199r_"};